<template>
  <div class="sc-typing-indicator">
    <span v-if="showText" class="sc-typing-indicator__text">{{ displayText }}</span>
    <span class="sc-typing-indicator__dots" aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
    </span>
  </div>
</template>
<script>

export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    showText: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    displayText () {
      return this.text || this.$t('interface.thinking')
    }
  }
}
</script>
